import { connect } from 'react-redux';
import { selectProducts } from 'Favourites/store/reducers/data/products';

import {
    selectShoppingListView,
} from 'store/reducers/data/shoppingList';

const mapStateToProps = (state) => {
    return {
        products: selectProducts(state),
        shoppingListView: selectShoppingListView(state),
    };
};

export default connect(mapStateToProps);
